import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TournamentList, TournamentRankList } from '../interfaces/activity.interface';
import { ResponseData } from '../interfaces/response.interface';
import { BaseApi } from './base.api';

@Injectable({
  providedIn: 'root',
})
export class ActivityApi extends BaseApi {
  /**
   * 获取 tournament 列表
   *
   * @param params
   * @param params.startDto
   * @param params.startDto.current
   * @param params.startDto.orderDirection
   * @param params.startDto.size
   * @param params.endDto
   * @param params.endDto.current
   * @param params.endDto.orderDirection
   * @param params.endDto.size
   * @param params.preDto
   * @param params.preDto.current
   * @param params.preDto.orderDirection
   * @param params.preDto.size
   * @returns
   */
  getTournamentList(params: {
    startDto: {
      current: number;
      orderDirection: 'desc' | 'asc';
      size: number;
    };
    endDto: {
      current: number;
      orderDirection: 'desc' | 'asc';
      size: number;
    };
    preDto: {
      current: number;
      orderDirection: 'desc' | 'asc';
      size: number;
    };
  }): Observable<TournamentList> {
    const url = `${environment.apiUrl}/v1/resource/activity/getnewranklist`;
    return this.post<ResponseData<TournamentList>>(url, params).pipe(
      map(
        v =>
          v?.data || {
            endList: null,
            startList: null,
            perList: null,
          },
      ),
    );
  }

  /**
   * tournament 报名
   *
   * @param params
   * @param params.tmpCode
   * @returns
   */
  onTournamentApply(params: { tmpCode: string }): Observable<boolean> {
    const url = `${environment.apiUrl}/v1/resource/activity/newrankactivityapply`;
    return this.post<ResponseData<boolean>>(url, params).pipe(map(v => v?.data || false));
  }

  /**
   * 获取 tournament 排名
   *
   * @param params
   * @param params.gameTypeDto 活动内页传
   * @param params.gameTypeDto.gameCategory
   * @param params.gameTypeDto.gameCode
   * @param params.gameTypeDto.gameProvider
   * @param params.tmpCodes 竞赛活动主页传
   * @param params.current
   * @param params.size
   * @returns
   */
  tournamentRankList(params: {
    gameTypeDto?: {
      gameCategory: string;
      gameCode: string;
      gameProvider: string;
    };
    tmpCodes?: string[];
    current?: number;
    size?: number;
  }): Observable<TournamentRankList[]> {
    const url = `${environment.apiUrl}/v1/resource/activity/getnewrankresult`;
    return this.post<ResponseData<TournamentRankList[]>>(url, params).pipe(map(v => v?.data || []));
  }

  /**
   * tournament 详情页面 是否可以报名
   *
   * @param params
   * @param params.tmpCodes
   * @returns
   */
  onNewRankCheckApply(params: { tmpCodes: string[] }): Observable<{ canJoin: boolean; tmpCode: string }[]> {
    const url = `${environment.apiUrl}/v1/resource/activity/newrankcheckapply`;

    return this.post<ResponseData<{ canJoin: boolean; tmpCode: string }[]>>(url, params).pipe(map(v => v?.data || []));
  }
}
